var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{ref:"qrCodeUrl",staticClass:"qrcode"}),_c('div',{staticClass:"code"},[_vm._v(" 核验码："+_vm._s(_vm.code)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }